import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  IconButton,
  Skeleton,
  Typography,
  Box,
} from '@mui/material';
import { Sort as SortIcon } from '@mui/icons-material';
import LeadRow from './LeadRow';
import { getStatusColor } from './utils';
import SearchBar from './SearchBar';

const LeadTable = ({
  leads,
  loading,
  pagination,
  sort,
  onOpenMenu,
  processingId,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
  onDownloadFile,
  canViewListLead = true
}) => {

  if (!canViewListLead) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="text.secondary">
          You don't have permission to view leads.
        </Typography>
      </Paper>
    );
  }
  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'grey.100' }}>
              <TableCell />

              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Phone</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Status
                  <IconButton
                    size="small"
                    onClick={() => onSortChange('status')}
                    color={sort.sort_by === 'status' ? 'primary' : 'default'}
                  >
                    <SortIcon />
                  </IconButton>
                </Box>
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Assignee</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Created
                  <IconButton
                    size="small"
                    onClick={() => onSortChange('created_at')}
                    color={sort.sort_by === 'created_at' ? 'primary' : 'default'}
                  >
                    <SortIcon />
                  </IconButton>
                </Box>
              </TableCell>
              <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(pagination.pageSize)].map((_, i) => (
                <TableRow key={i}>
                  <TableCell><Skeleton height={30} width={40} /></TableCell>
                  {[...Array(6)].map((_, j) => (
                    <TableCell key={j}><Skeleton height={30} /></TableCell>
                  ))}
                  <TableCell><Skeleton height={30} width={40} /></TableCell>
                </TableRow>
              ))
            ) : leads.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                  <Typography>No leads available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              leads.map((lead) => (
                <LeadRow
                  key={lead.id}
                  row={lead}
                  onOpenMenu={onOpenMenu}
                  processingId={processingId}
                  onDownloadFile={onDownloadFile}
                  canViewListLead={canViewListLead}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {!loading && leads.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={pagination.total}
          rowsPerPage={pagination.pageSize}
          page={pagination.page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

// Attach SearchBar as a static property
LeadTable.SearchBar = ({ searchValue, onSearchChange, onClearSearch, placeholder, sx }) => (
  <SearchBar
    searchValue={searchValue}
    onSearchChange={onSearchChange}
    onClearSearch={onClearSearch}
    placeholder={placeholder}
    sx={sx}
  />
);

export default LeadTable;